import React, { useState } from 'react'

const ContactUs: React.FunctionComponent = () => {
  return <div className='d-flex justify-content-center'></div>
}

export default ContactUs
